import { createSelector } from '@reduxjs/toolkit';

import { TRootState } from '../index';
import { ISessionSettingsState } from './session-settings.slice';

/**
 A selector function to retrieve the session settings data from the store
 @function
 @param {TRootState} state - The root state of the Redux store
 @returns {ISessionSettingsState} The session settings state object from the Redux store
 */
const selectSessionSettingsState = (state: TRootState): ISessionSettingsState => state.sessionSettings;

/**
 A memoized selector function to retrieve the session settings state from the store
 @function
 @type {import('@reduxjs/toolkit').OutputSelector<RootState, ISessionSettingsState, (res: ISessionSettingsState) => ISessionSettingsState>}
 */
export const getSessionSettingsState = createSelector(
  [selectSessionSettingsState],
  (state): ISessionSettingsState => state
);
